import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import CommentOutline from '../../../Icons/24x24/CommentOutline';
import { BiEventType, BiDataHook } from '../../../biLogger/constants';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
var CommentButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, deviationId = _b.deviationId, author = _b.author, extended = _b.extended, onToggleCommentPanel = _a.onToggleCommentPanel, isCommentPanelOpen = _a.isCommentPanelOpen, isOwner = _a.isOwner, actionBarType = _a.actionBarType;
    var t = useTranslation().t;
    var onClick = function () {
        if (!extended) {
            return;
        }
        onToggleCommentPanel(deviation, actionBarType);
    };
    return (React.createElement(ActionBarButton, { tooltip: isOwner ? t('actionbar.comment') : undefined, isRelatedPanelOpen: isCommentPanelOpen, onClick: onClick, dataHook: BiDataHook.DEVIATION_COMMENT_BUTTON, biData: {
            evid: BiEventType.THUMB_CLICK_COMMENT,
            typeid: getDeviationResourceType(deviation),
            creatorid: author && author.useridUuid,
            itemid: deviationId,
        }, label: isOwner ? undefined : t('actionbar.comment') },
        React.createElement(ActionBarIcon, { icon: CommentOutline })));
};
CommentButton.displayName = 'CommentButton';
export default CommentButton;
//# sourceMappingURL=CommentButton.js.map